import React from 'react';

export default function CartItemDvdIcon(props) {
  return (
    <div className="cart-item-dvd-icon-container">
      <div className="cart-item-dvd-icon">
        <div className="cart-item-dvd-icon-inner-circle">
          <div className="cart-item-dvd-icon-hole" />
        </div>
      </div>
    </div>
  );
}
